/*
 * The PAF quick search module
 */
var TECL_PafQuickSearch = {

  //increment: 0,
  lastProcessedId: 0,
  acSnippet: '<ul class="ac-dropdown"></ul>',

  // Initialise the PAF search controls
  Initialise: function (selector) {

    var mouseIsIn;
    var $selectorElement = $(selector);

    $selectorElement.on("focus", function (e) {
      query = $(this).val();
      TECL_PafQuickSearch.Search(this, query);
    });

    $selectorElement.on("blur", function (e) {
      if (!mouseIsIn) {
        TECL_PafQuickSearch.RemoveDropdown(this);
      }
    });

    $selectorElement.on("input propertychange paste", function () {
      const $inputCntrl = $(this);
      $inputCntrl.attr("data_id", "");
      $inputCntrl.attr("data_name", "");
      $inputCntrl.attr("data_addressLine1", "");
      $inputCntrl.attr("data_addressLine2", "");
      $inputCntrl.attr("data_addressLine3", "");
      $inputCntrl.attr("data_town", "");
      $inputCntrl.attr("data_countyName", "");
      $inputCntrl.attr("data_countryId", "");
      $inputCntrl.attr("data_postcode", "");
      $inputCntrl.attr("data_gridEast", "");
      $inputCntrl.attr("data_gridNorth", "");
      $inputCntrl.attr("data_latitude", "");
      $inputCntrl.attr("data_longitude", "");
      $inputCntrl.attr("data_leaCode", "");

      query = $inputCntrl.val();
      TECL_PafQuickSearch.Search(this, query);
      TECL_PafQuickSearch.TriggerCustomEvent(this);
    });

    $selectorElement.on("keydown", function (e) {
      if (e.keyCode === 40) {
        TECL_PafQuickSearch.HighlightItemBeneath(this);
      }

      if (e.keyCode === 38) {
        TECL_PafQuickSearch.HighlightItemAbove(this);
      }

      if (e.keyCode === 13 || e.keyCode === 9) {

        var $item = $(this);

        if ($item.next().hasClass("ac-dropdown")) {

          e.preventDefault();

          if ($item.next().find(".interested").length > 0) {
            var valueName = $item.next().children(".interested").first().attr("data_name");
            var valueId = $item.next().children(".interested").first().attr("data_id");
            TECL_PafQuickSearch.SelectItem(this, valueId, valueName);
          }
        }
      }
    });

    $(document).on("mouseenter", ".ac-dropdown", function (e) {
      mouseIsIn = true;
    });

    $(document).on("mouseleave", ".ac-dropdown", function (e) {
      mouseIsIn = false;
    });

    $(document).on("click", ".ac-option", function (e) {
      const $item = $(this);
      const valueId = $item.attr("data_id");
      const valueName = $item.attr("data_name");

      const autocomplete = $item.parent().prev();

      TECL_PafQuickSearch.SelectItem(autocomplete, valueId, valueName);

      $(autocomplete).trigger("itemSelected", [valueId, valueName]);
      TECL_PafQuickSearch.RemoveDropdown(autocomplete);
    });

    $(document).on("click", ".ac-no-results", function (e) {
      autocomplete = $(this).parent().prev();
      TECL_PafQuickSearch.RemoveDropdown(autocomplete);
    });
  },

  // Hide the dropdown
  RemoveDropdown: function (element) {
    if ($(element).next().hasClass("ac-dropdown")) {
      $(element).next().hide(200, function () { $(element).next().remove() });
    }
  },

  // Create and open the dropdown
  CreateDropdown: function (element, data) {
    if (!$.isEmptyObject(data.results)) {
      if (parseInt(data.requestId) > parseInt(TECL_PafQuickSearch.lastProcessedId)) {
        if (!$(element).next().hasClass("ac-dropdown")) {
          $(element).after(TECL_PafQuickSearch.acSnippet);
        }

        $(element).next().empty();

        $.each(data.results,
          function (i, item) {
            $(element).next().append('<li class="ac-option" data_name="' + item.AddressText + '" data_id="' + item.PostKey + '">' + item.AddressText + '</li>');
          });
        TECL_PafQuickSearch.lastProcessedId = data.requestId;
      }
    } else {
      $(element).next().empty();
      $(element).next().append('<li class="ac-no-results">No results found</li>');
    }
  },

  // Search for PAF's
  Search: function (element, query) {
    if (query == null) {
      query = "";
    }
    if (query.length > 2) {
      $.ajax({
        url: "/umbraco/surface/GenericCheckoutSurface/SearchAfdAddresses/",
        data: {
          searchText: query,
          requestId: TECL_OrgQuickSearch.increment,
        },
        success: function (results) {
          TECL_PafQuickSearch.CreateDropdown(element, results);
        }
      });
      TECL_OrgQuickSearch.increment++;
    }
  },

  // Highlight items below
  HighlightItemBeneath: function (element) {
    var currentHighlightedItem = $(element).next().children(".interested");

    if (currentHighlightedItem.length == 0) {
      $(element).next().children().first().addClass("interested");
    } else {
      currentHighlightedItem.next().addClass("interested");
      currentHighlightedItem.removeClass("interested");
    }
  },

  // Highlight items above
  HighlightItemAbove: function (element) {
    var currentHighlightedItem = $(element).next().children(".interested");

    if (currentHighlightedItem.length == 0) {
      $(element).next().children().first().addClass("interested");
    } else {
      currentHighlightedItem.prev().addClass("interested");
      currentHighlightedItem.removeClass("interested");
    }
  },

  // Select an item
  SelectItem: function (element, valueId, valueName) {
    var $inputCntrl = $(element);
    $inputCntrl.val(valueName);
    $inputCntrl.attr("data_id", valueId);
    $inputCntrl.attr("data_name", valueName);

    $.ajax({
      url: "/umbraco/surface/GenericCheckoutSurface/GetFullAddress/",
      data: {
        addressKey: valueId
      },
      success: function (results) {
        $inputCntrl.attr("data_addressLine1", results.AddressLine1);
        $inputCntrl.attr("data_addressLine2", results.AddressLine2);
        $inputCntrl.attr("data_addressLine3", results.AddressLine3);
        $inputCntrl.attr("data_town", results.Town);
        $inputCntrl.attr("data_countyName", results.CountyName);
        $inputCntrl.attr("data_countryId", results.CountryId);
        $inputCntrl.attr("data_postcode", results.Postcode);
        $inputCntrl.attr("data_gridEast", results.GridEast);
        $inputCntrl.attr("data_gridNorth", results.GridNorth);
        $inputCntrl.attr("data_latitude", results.Latitude);
        $inputCntrl.attr("data_longitude", results.Longitude);
        $inputCntrl.attr("data_leaCode", results.LeaCode);

        TECL_PafQuickSearch.TriggerCustomEvent(element);
        TECL_PafQuickSearch.RemoveDropdown(element);
      }
    });
  },

  // Trigger the custom events
  TriggerCustomEvent: function (element) {
    var $inputCntrl = $(element);
    var dataId = $inputCntrl.attr("data_id");
    var dataName = $inputCntrl.attr("data_name");
    var dataAddressLine1 = $inputCntrl.attr("data_addressLine1");
    var dataAddressLine2 = $inputCntrl.attr("data_addressLine2");
    var dataAddressLine3 = $inputCntrl.attr("data_addressLine3");
    var dataTown = $inputCntrl.attr("data_town");
    var dataCountryName = $inputCntrl.attr("data_countyName");
    var dataCountryId = $inputCntrl.attr("data_countryId");
    var dataPostcoded = $inputCntrl.attr("data_postcode");
    var dataGridEast = $inputCntrl.attr("data_gridEast");
    var dataGridNorth = $inputCntrl.attr("data_gridNorth");
    var dataLatitude = $inputCntrl.attr("data_latitude");
    var dataLongitude = $inputCntrl.attr("data_longitude");
    var dataLeaCode = $inputCntrl.attr("data_leaCode");

    var value = $inputCntrl.val();

    if (dataName != value) {
      dataId = "";
      dataName = "";
      dataAddressLine1 = "";
      dataAddressLine2 = "";
      dataAddressLine3 = "";
      dataTown = "";
      dataCountryName = "";
      dataCountryId = "";
      dataPostcoded = "";
      dataGridEast = "";
      dataGridNorth = "";
      dataLatitude = "";
      dataLongitude = "";
      dataLeaCode = "";
    }

    $(element).trigger("itemSelected", [dataId, dataName, dataAddressLine1, dataAddressLine2, dataAddressLine3, dataTown, dataCountryName, dataCountryId, dataPostcoded, dataGridEast, dataGridNorth, dataLatitude, dataLongitude, dataLeaCode]);
  }

};
